import { render, staticRenderFns } from "./sliderObras.vue?vue&type=template&id=786b30f6&"
import script from "./sliderObras.vue?vue&type=script&lang=js&"
export * from "./sliderObras.vue?vue&type=script&lang=js&"
import style0 from "./sliderObras.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports